import { Box, Paper, Stack, Typography } from '@mui/material';
import { PublicHeader } from '../components/PublicHeader';
import { grey } from '@mui/material/colors';

export function LegalDocumentsBg() {
  return (
    <>
      <PublicHeader />
      <Box
        bgcolor="background.default"
        sx={{
          backgroundColor: grey[100],
          backgroundPosition: 'center',
          height: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Paper sx={{ width: 600, padding: 5, margin: 'auto' }}>
          <Typography variant="h4" align="start" sx={{ marginBottom: 10 }} color="primary">
            Правни документи
          </Typography>
          <Stack spacing={2}>
            <Stack spacing={1} direction="row">
              <a target="_blank" rel="noreferrer" href="https://api.fastai.tech/agreements/general_terms_2023-11-01.html">
                Общи условия
              </a>
              <a style={{ textDecoration: 'none' }} target="_blank" rel="noreferrer" href="https://api.fastai.tech/agreements/general_terms_2023-11-01.pdf">
                (pdf)
              </a>
            </Stack>
            <Stack spacing={1} direction="row">
              <a target="_blank" rel="noreferrer" href="https://api.fastai.tech/agreements/data_processing_aggreement_latest.html">
                Споразумение за обработка на лични данни
              </a>
              <a style={{ textDecoration: 'none' }} target="_blank" rel="noreferrer" href="https://api.fastai.tech/agreements/data_processing_aggreement_latest.pdf">
                (pdf)
              </a>
            </Stack>
            <Stack spacing={1} direction="row">
              <a target="_blank" rel="noreferrer" href="https://api.fastai.tech/agreements/privacy_2023-11-01.html">
                Политика за поверителност
              </a>
              <a style={{ textDecoration: 'none' }} target="_blank" rel="noreferrer" href="https://api.fastai.tech/agreements/privacy_2023-11-01.pdf">
                (pdf)
              </a>
            </Stack>
            <Stack spacing={1} direction="row">
              <a target="_blank" rel="noreferrer" href="https://api.fastai.tech/agreements/informed_consent.html">
                Информирано съгласие
              </a>
              <a style={{ textDecoration: 'none' }} target="_blank" rel="noreferrer" href="https://api.fastai.tech/agreements/informed_consent.pdf">
                (pdf)
              </a>
            </Stack>
            <Stack spacing={1} direction="row">
              <a target="_blank" rel="noreferrer" href="https://api.fastai.tech/agreements/informed_consent_affidavit.html">
                Информирано съгласие настойник/пълномощник
              </a>
              <a style={{ textDecoration: 'none' }} target="_blank" rel="noreferrer" href="https://api.fastai.tech/agreements/informed_consent_affidavit.pdf">
                (pdf)
              </a>
            </Stack>
          </Stack>
        </Paper>
      </Box>
    </>
  );
}
